import { HttpServiceBase } from '../../../common-services/Http/HttpServiceBase';
import { ToastService } from '../../../common-services/Toast/ToastService';
import { strings } from '../../../resources/strings';
import { ReportService } from '../ReportService';
import { GenerateSeparationListReportInput } from './GenerateSeparationListReportInput';

export class GenerateSeparationListReportService extends HttpServiceBase {

  constructor(
    private report: ReportService,
    private toaster: ToastService,
    http?: any | null
  ) {
    super(http);
  }

  handle = (input: GenerateSeparationListReportInput, callback?: (success: boolean) => void) => {
    this.http.postToDownloadFile<GenerateSeparationListReportInput>(
      `${this.baseUrlSislogV2Api}/v2/report-separation-list`,
      input
    ).then(result => {
      this.report.openPdf(result);
      callback?.(true);
    }).catch(error => {
      this.toaster.warning(strings.OpsSomethingWrongGeneratingReport);
      callback?.(false);
    });
  }
}